import React, { Component } from 'react';
import { getDeviceKindDependsOnViewPort } from '@bitComponents/utils/common';
import { DEVICES } from '@bitComponents/utils/constants';
import SvgPicture from './cloudIsland.svg';

const DESKTOP_WIDTH = 1920;
const DESKTOP_HEIGHT = 540;
const MOBILE_WIDTH = 1245;
const MOBILE_HEIGHT = 350;

const calculateBackgroundProps = () => {
  const currentDevice = getDeviceKindDependsOnViewPort();
  const screenWidth = window.innerWidth;
  let leftSize = (screenWidth - DESKTOP_WIDTH) / 2;
  let backgroundSize = `${DESKTOP_WIDTH}px ${DESKTOP_HEIGHT}px`;
  if (currentDevice === DEVICES.MOBILE) {
    leftSize = (screenWidth - MOBILE_WIDTH) / 2;
    backgroundSize = `${MOBILE_WIDTH}px ${MOBILE_HEIGHT}px`;
  }
  if (leftSize > 0) {
    leftSize = 0;
  }
  const backgroundPosition = `${leftSize}px 0px`;
  const backgroundImage = `url(${SvgPicture})`;

  return {
    backgroundPosition,
    backgroundSize,
    backgroundImage,
  };
};

class Beach extends Component {
  state = {
    ...calculateBackgroundProps(),
  };

  setBackgroundProps = () => {
    const data = calculateBackgroundProps();
    this.setState({ ...data });
  };

  componentWillUnmount = () => {
    window.removeEventListener('resize', this.setBackgroundProps);
  };

  componentDidMount = () => {
    window.addEventListener('resize', this.setBackgroundProps);
  };

  render() {
    const { backgroundSize, backgroundPosition, backgroundImage } = this.state;

    return (
      <div
        className="BeachBackground"
        style={{
          backgroundImage,
          backgroundPosition,
          backgroundSize,
        }}
      />
    );
  }
}

export default Beach;
